import { getMarketMetaArray } from "./get-market-meta-array";
import { getMarketProtocolKeyMap } from "./get-market-protocol-key-map";
import { getShareTokenMeta } from "./get-share-token-meta";
import { getTokenPriceMap } from "./get-token-price-map";
import { getTokenPriceKey } from "./keys";
import {
  getMerklCampaignMeta,
  setMerklCampaignMeta,
} from "./merkl-campaign-meta";
import {
  getMerklUserRewardsInfo,
  setMerklUserRewardsInfo,
} from "./merkl-user-rewards-info";
import { KvService, KvTokenPrice } from "./types";
import { updateMarketMeta } from "./update-market-meta";

export const KvClient = {
  KvService,
  KvTokenPrice,

  getMarketMetaArray,
  getMarketProtocolKeyMap,
  getMerklCampaignMeta,
  getMerklUserRewardsInfo,
  getShareTokenMeta,
  getTokenPriceMap,
  setMerklCampaignMeta,
  setMerklUserRewardsInfo,
  updateMarketMeta,

  getTokenPriceKey,
};
